import { Fragment, memo } from 'react';
import { useSelector } from 'react-redux';

import { GuardedDelete } from 'primary-components';

import GroupDialog from 'components/modules/Datalake/Lists/Groups/GroupDialog';
import SearchAll from 'components/modules/SearchAll';
import Statuses from 'components/modules/Statuses';
import BasicCSVEditor from 'primary/BasicCSVEditor';
import CodeEditor from 'primary/CodeEditor';
import CSVEditor from 'primary/CSVEditor';
import FtlEditor from 'primary/FtlEditor';
import HtmlEditor from 'primary/HtmlEditor';
import ImagePreview from 'primary/ImagePreview';
import Inspector from 'primary/Inspector';
import MarkDownEditor from 'primary/MarkDownEditor';
import NCSVCreator from 'primary/NCSVCreator';
import PdfViewer from 'primary/PdfViewer';
import PythonEditor from 'primary/PythonEditor';

import { When } from 'react-if';

const Tools = () => {
  const markdownEditorActive = useSelector(state => state.primaryComponentsState.markdownEditorState.open),
        htmlEditorActive = useSelector(state => state.toolsState.htmlEditorState.open),
        ftlEditorActive = useSelector(state => state.toolsState.ftlEditorState.open),
        pdfViewerActive = useSelector(state => state.toolsState.pdfViewerState.open),
        imgPreviewActive = useSelector(state => state.toolsState.imagePreviewState.isOpen),
        codeEditorActive = useSelector(state => state.toolsState.codeEditorState.open),
        pythonEditorActive = useSelector(state => state.toolsState.pythonEditorState.isOpen),
        csvBasicEditorState= useSelector(state => state.toolsState.csvBasicEditorState.open),
        csvEditorActive = useSelector(state => state.toolsState.csvEditorState.open),
        ncsvCreatorActive = useSelector(state => state.toolsState.ncsvCreatorState.open),
        inspectorActive = useSelector(state => state.toolsState.inspectorState.open),
        isGroupDialogOpen = useSelector(state => state.datalakeState.groupDialogState.isOpen),
        isGuardedDeleteOpen = useSelector(state => state.primaryComponentsState.guardedDeleteState.isOpen)
  
  return (
    <Fragment>
      <SearchAll/>
      <Statuses/>
      <When condition={markdownEditorActive}>
        {() => <MarkDownEditor/>}
      </When>
      <When condition={htmlEditorActive}>
        {() => <HtmlEditor/>}
      </When>
      <When condition={ftlEditorActive}>
        {() => <FtlEditor/>}
      </When>
      <When condition={imgPreviewActive}>
        {() => <ImagePreview/>}
      </When>
      <When condition={pdfViewerActive}>
        {() => <PdfViewer/>}
      </When>
      <When condition={codeEditorActive}>
        {() => <CodeEditor/>}
      </When>
      <When condition={pythonEditorActive}>
        {() => <PythonEditor/>}
      </When>
      <When condition={csvBasicEditorState}>
        {() => <BasicCSVEditor/>}
      </When>
      <When condition={csvEditorActive}>
        {() => <CSVEditor/>}
      </When>
      <When condition={ncsvCreatorActive}>
        {() => <NCSVCreator/>}
      </When>
      <When condition={inspectorActive}>
        {() => <Inspector/>}
      </When>
      <When condition={isGroupDialogOpen}>
        {() => <GroupDialog/>}
      </When>
      <When condition={isGuardedDeleteOpen}>
        {() => (
          <GuardedDelete/>
        )}
      </When>
    </Fragment>
  );
}

export default memo(Tools);
